import React from 'react'
import { FormattedMessage, MessageDescriptor } from 'react-intl'
import { css, cx } from '@emotion/css'
import { theme } from '../../styled'
import { drilldownPageTitleCss } from '../../legacy-design-system/text'

export interface HeaderProps {
  readonly title: MessageDescriptor
  readonly subtitle: MessageDescriptor
}

const titleCss = css`
  font-weight: ${theme.fontWeights.secondary.bold};
  font-size: 20px;
`

const subtitleCss = css`
  font-family: ${theme.fontFamilies.primary};
  font-weight: ${theme.fontWeights.primary.regular};
  font-size: 17px;
`

export function Header({ title, subtitle }: HeaderProps) {
  return (
    <div>
      <div
        className={cx(drilldownPageTitleCss, titleCss)}
        children={<FormattedMessage {...title} />}
      />
      <div
        className={subtitleCss}
        children={<FormattedMessage {...subtitle} />}
      />
    </div>
  )
}
